import React from 'react';
import { Breadcrumb as BreadcrumbNew } from './Breadcrumb';
import { convertOldBreadcrumbProps } from './converter.old';
import type { OldBreadcrumbItem, OldBreadcrumbProps } from './converter.old';

export type BreadcrumbItem = OldBreadcrumbItem;
export type BreadcrumbProps = OldBreadcrumbProps;

export const Breadcrumb: React.FC<BreadcrumbProps> = (props) => <BreadcrumbNew {...convertOldBreadcrumbProps(props)} />;
